import { render, staticRenderFns } from "./OTDChart.vue?vue&type=template&id=5db66068&scoped=true&"
import script from "./OTDChart.vue?vue&type=script&lang=js&"
export * from "./OTDChart.vue?vue&type=script&lang=js&"
import style0 from "./OTDChart.vue?vue&type=style&index=0&id=5db66068&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db66068",
  null
  
)

export default component.exports